import axios from 'axios';
import { URI_EMAIL_VALIDATION } from '../helpers/constans';

export const fetchEmailValidation = (key: string): Promise<any> => {
  return axios.get(`${URI_EMAIL_VALIDATION}${key}`);
};
